/**
 * Returns a shortened string by replacing middle characters with '...'
 */
export function reduceString(
  str: string,
  from: number = 4,
  end: number = 4,
): string {
  if (!str) return '-';

  return str && typeof str.substring === 'function'
    ? `${str.substring(0, from)}...${str.substring(str.length - end)}`
    : '-';
}

/**
 * Formats a time period in seconds to human readable format
 */
export function formatTimePeriod(seconds: number): string {
  const units = [
    { label: 'second', value: 1 },
    { label: 'minute', value: 60 },
    { label: 'hour', value: 3600 },
    { label: 'day', value: 86400 },
    { label: 'week', value: 604800 },
    { label: 'month', value: 2592000 },
    { label: 'year', value: 31557600 },
  ];

  for (let i = units.length - 1; i >= 0; i--) {
    const unit = units[i];
    if (seconds >= unit.value) {
      const count = Math.floor(seconds / unit.value);
      return `${count} ${unit.label}${count > 1 ? 's' : ''}`;
    }
  }
  return 'just now';
}
